import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'Shared/util/custom-hooks';
import PropTypes from 'prop-types';
import makeComponentTrashable from 'trashable-react';
import useTranslationContext from 'Contexts/translation-context';
import { forgotPassword } from 'Shared/util/web-api';
import InputText from 'Shared/components/input-text';
import Button from 'Shared/components/button';
import { getLink } from 'Shared/navigation/login/routes';
import styles from '../login.css';


const ForgotPasswordForm = ({
  registerPromise, dispatchStatusMessage,
}) => {
  const [email, setEmail] = useState('');
  const [validEmail, setValidEmail] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const history = useHistory();
  const { translationData } = useTranslationContext();
  const t = useTranslation(x => x.login);

  const submitForm = (e) => {
    setIsLoading(true);
    registerPromise(forgotPassword(email, translationData.languageCode))
      .then(() => {
        setIsLoading(false);
        const redirectStatusMessage = {
          type: 'SUCCEEDED',
          message: t.restoreLinkHasBeenSentToYourEmail,
        };
        history.push({
          pathname: getLink('login'),
          state: {
            message: redirectStatusMessage,
          },
        });
      })
      .catch(() => {
        dispatchStatusMessage({
          type: 'FAILED',
          message: t.somethingWentWrongMakeSureYouEnteredCorrectEmail,
        });
        setIsLoading(false);
      });
    e.preventDefault();
  };

  const isSubmitEnabled = validEmail;

  return (
    <>
      <form onSubmit={(e) => submitForm(e)}>
        <InputText
          inputType="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          setEnabledSubmit={(bool) => setValidEmail(bool)}
          isRequired
        />
        <Button
          className={styles.submitButton}
          buttonType="action-primary"
          isLoading={isLoading}
          text={t.send}
          attributes={{ type: 'submit', disabled: !isSubmitEnabled }}
        />
      </form>
    </>
  );
};

export default makeComponentTrashable(ForgotPasswordForm);

ForgotPasswordForm.propTypes = {
  registerPromise: PropTypes.func.isRequired,
  dispatchStatusMessage: PropTypes.func.isRequired,
};
